import apiClient from './apiClient';

export interface QueryParams {
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  vendor_from?: string;
  vendor_to?: string;
  product_from?: string;
  product_to?: string;
  process_from?: string;
  process_to?: string;
  dept_from?: string;
  dept_to?: string;
}

export interface ReportRow {
  FD130_12: string;      // vendor code
  vendor_name: string;
  FD130_01: string;      // order no
  FD130_11: string;      // order date
  FD130_15: string;      // process code
  FD130_19: string;      // unit
  qty: number;
  amount: number;
}

export interface VendorCount {
  code: string;
  name: string;
  count: number;
}

export interface UnitSummary {
  FD130_19: string;   // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface QueryResponse {
  data: ReportRow[];
  count: number;
  group_counts: VendorCount[];
  unit_summary: UnitSummary[];
  message?: string;
}

export const d303Api = {
  async query(params: QueryParams): Promise<QueryResponse> {
    const res = await apiClient.post('/api/d303/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d303/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
